function excerpt(post) {
    return (post.subtitle || post.content || '').replace(/\[\[image:[23]\]\]/g, '').replace(/<[^>]*>/g, '').replace(/!\[[^\]]*\]\([^)]*\)/g, '').replace(/\[([^\]]*)\]\([^)]*\)/g, '$1').replace(/[#*_`>]/g, '').replace(/\s+/g, ' ').trim().slice(0, 220);
}
module.exports = { excerpt };
